<template>
  <!-- services -->
  <div class="services" id="services">
    <div class="container text-center">
      <h3 class="customHeader h1">Services</h3>
      <div class="row">
        <div
          class="col-md-3 col-sm-6 serCol"
          v-for="route in routes"
          :key="route.name"
        >
          <router-link :to="`/services/${route.param}`">
            <div class="ser shadow">
              <div class="overl"></div>
              <div class="overl2"></div>
              <img :src="route.img" alt="HOPITAL" class="lazy" />
              <h4>{{ route.name }}</h4>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      routes: [
        {
          name: "AMBULANCE",
          param: "ambulences",
          img: require("@/assets/image/centre.png")
        },
        {
          name: "CENTRE D'IMAGERIE",
          param: "centres_dimagerie",
          img: require("@/assets/image/centre.png")
        },
        {
          name: "CLINIQUE",
          param: "clinics",
          img: require("@/assets/image/clinic.png")
        },
        {
          name: "LABORATOIRE",
          param: "laboratoires",
          img: require("@/assets/image/laboratoire.png")
        },
        {
          name: "OPTICIEN",
          param: "opticiens",
          img: require("@/assets/image/opticien.png")
        },
        {
          name: "PHARMACIE",
          param: "Pharmacies",
          img: require("@/assets/image/pharmacie.png")
        },
        {
          name: "DOCTEUR",
          param: "doctors",
          img: require("@/assets/image/centre.png")
        },
        {
          name: "MATERIEL MEDICAL",
          param: "Materiels_medicaux",
          img: require("@/assets/image/mater.png")
        },
        {
          name: "Dentistes",
          param: "dentists",
          img: require("@/assets/image/dentist.png")
        },
        {
          name: "VETERINAIRES",
          param: "veterinaires",
          img: require("@/assets/image/veterinaire.png")
        },
        {
          name: "PSYCHOLOGUES",
          param: "psychologues",
          img: require("@/assets/image/psychology.png")
        },
        {
          name: "HOPITAL",
          param: "hopital",
          img: require("@/assets/image/hopital.png")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.services {
  img {
    width: 90px;
  }
  a {
    text-decoration: none;
    .ser {
      /* box-shadow: 0 12px 18px rgba(0,0,0,0.30), 0 1px 12px rgba(0,0,0,0.22); */
      margin: 10px;
      padding: 20px 0;
      border-radius: 15px;
      position: relative;
      h4 {
        font-size: 1.3rem !important;
      }
      .overl {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000098;
        transition: all 0.5s ease;
        clip-path: circle(0);
        z-index: -2;
      }
      .overl2 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        transition: all 0.4s ease;
        transition-delay: 0.3s;
        clip-path: circle(0);
        z-index: -1;
      }
      &:active .overl {
        clip-path: circle(230px);
      }
      &:active {
        color: #0f7bbc;
        text-shadow: 0 0 1px #fff;
      }

      &:active .overl2 {
        clip-path: circle(230px);
      }
    }
  }
}
</style>